import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { Awaitable } from '@ipfabric/ui-components/utils/types/Awaitable';
import type { GlobalStateDispatch } from './GlobalStateModel';

let dispatchFn: GlobalStateDispatch | null = null;

export const setGlobalStateDispatch = (
  fn: GlobalStateDispatch | null,
): void => {
  dispatchFn = fn;
};

export const unsafeGlobalStateDispatch: GlobalStateDispatch = (
  command: any,
  ...commandArguments: any[]
): Awaitable<void> => {
  if (dispatchFn) {
    return dispatchFn(command, ...commandArguments);
  }
  stumble('Trying to call global state dispatch that is not yet available');
  return undefined;
};
